import React from 'react';

function Header() {
  return (
    <nav
      style={{
        position: 'fixed',
        top: 0,
        width: '100%',
        padding: '1.5rem 5%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        zIndex: 100,
        background: 'rgba(5, 5, 5, 0.8)',
        backdropFilter: 'blur(10px)',
        borderBottom: '1px solid rgba(255,255,255,0.1)',
      }}
    >
      {/* Logo */}
      <a
        href="#home"
        className="logo"
        style={{
          fontSize: '1.8rem',
          fontWeight: 800,
          letterSpacing: '1px',
          textDecoration: 'none',
          color: 'white',
        }}
      >
        Cloud<span style={{ color: '#00ffcc' }}>Nest</span>
      </a>

      <div className="nav-links" style={{ display: 'flex', gap: '2rem' }}>
        {['about', 'services', 'work', 'contact'].map((item) => (
          <a
            key={item}
            href={`#${item}`}
            style={{
              color: 'white',
              textDecoration: 'none',
              fontWeight: 500,
              fontSize: '0.9rem',
              textTransform: 'uppercase',
              letterSpacing: '1px',
              transition: 'color 0.3s',
            }}
            onMouseEnter={e => (e.target.style.color = '#00ffcc')}
            onMouseLeave={e => (e.target.style.color = 'white')}
          >
            {item.charAt(0).toUpperCase() + item.slice(1)}
          </a>
        ))}
      </div>
    </nav>
  );
}

export default Header;
